import LoadingCover from './LoadingCover';

export default LoadingCover;
